module.exports = __webpack_public_path__ + "748d304cc84da79027a91a6662fce411.otf";